import Contents from './Contents';
import Description from './Description';
import Feedback from './Feedback';
import Guide from './Guide';
import Section from './Section';

Description.Guide = Guide;
Description.Feedback = Feedback;
Description.Contents = Contents;
Description.Section = Section;
export default Description;
